import { reactive } from 'vue';

export const eventBus = reactive({
    showSessionTimeout: false,
    
    triggerSessionTimeout() {
        console.log('🚨 triggerSessionTimeout called');
        this.showSessionTimeout = true;
        console.log('🚨 showSessionTimeout set to:', this.showSessionTimeout);
    },
    
    hideSessionTimeout() {
        console.log('✅ hideSessionTimeout called');
        this.showSessionTimeout = false;
        console.log('✅ showSessionTimeout set to:', this.showSessionTimeout);
    }
});